(()=>{
  const reduced=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initJourney=root=>{
    if(!root||root.dataset.klxJourneyReady==='true')return;
    const rail=root.querySelector('[data-klx-journey-rail]');
    const prev=root.querySelector('[data-klx-journey-prev]');
    const next=root.querySelector('[data-klx-journey-next]');
    if(!rail||!prev||!next)return;
    root.dataset.klxJourneyReady='true';

    const stepSize=()=>{
      const card=rail.querySelector('.klx-journey-step');
      if(!card)return Math.max(260,rail.clientWidth*.82);
      const styles=getComputedStyle(rail);
      const gap=parseFloat(styles.columnGap||styles.gap||'0')||0;
      return card.getBoundingClientRect().width+gap;
    };
    const update=()=>{
      if(window.innerWidth>900){prev.disabled=false;next.disabled=false;return;}
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth-2);
      prev.disabled=rail.scrollLeft<=3;
      next.disabled=rail.scrollLeft>=max;
    };
    const move=dir=>rail.scrollBy({left:dir*stepSize(),behavior:reduced()?'auto':'smooth'});
    prev.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  };

  const polishFaq=()=>{
    document.querySelectorAll('.klx-faq').forEach(faq=>{
      const section=faq.closest('.klx-section');
      if(section)section.classList.add('klx-faq-section--premium');
    });
  };

  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-klx-faq-button]');
    if(!button)return;
    requestAnimationFrame(()=>{
      const item=button.closest('.klx-faq__item');
      const faq=button.closest('.klx-faq');
      if(!item||!faq||!item.classList.contains('is-open'))return;
      faq.querySelectorAll('.klx-faq__item.is-open').forEach(other=>{
        if(other===item)return;
        other.classList.remove('is-open');
        other.querySelector('[data-klx-faq-button]')?.setAttribute('aria-expanded','false');
      });
    });
  });

  const init=()=>{
    document.querySelectorAll('[data-klx-journey]').forEach(initJourney);
    polishFaq();
    const observer=new MutationObserver(()=>polishFaq());
    observer.observe(document.body,{childList:true,subtree:true});
    window.setTimeout(()=>observer.disconnect(),8000);
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
